import { z } from 'zod';

export const englishIqResultSchema = z.object({
  cefr: z.string(),
  confidence: z.number(),
  createdAt: z.number().optional(),
  durationMs: z.number().int().nonnegative(),
  itemCount: z.number().int().nonnegative(),
  score: z.number().int(),
  shareId: z.string(),
  subBand: z.string(),
  weakestFamilies: z.array(z.string()),
});

export type IEnglishIqResult = z.infer<typeof englishIqResultSchema>;
